import React from "react";
import classNames from "classnames";
import {FaLocationPin} from "react-icons/fa6";
import {BiSolidChurch} from "react-icons/bi";

export const MassTimeFillSvg = ({size = 20, ...props}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path fill="currentColor" d="M93.436 226.968a3.416 3.416 0 01.912-.456c20.279-13.223 49.833-4.963 62.851 10.034 8.361 7.37 15.5 13.754 30.477 13.754 32.489-.8 32.687-31.03 68.4-30.4 35.635-.6 35.9 29.635 68.4 30.4 14.9 0 22.116-6.385 30.4-13.757 13.083-15.085 42.641-23.21 62.852-10.032l.456.228c13.581 8.145 20.023 21.046 37.316 23.18V202.8a24.748 24.748 0 00-24.7-24.7H81.2a24.748 24.748 0 00-24.7 24.7v47.12c17.057-2.099 23.708-14.807 36.936-22.952zM128.7 119.2c.051-6.114-5.556-10.211-11.4-9.5V85.988a18.268 18.268 0 01-11.4 0V109.7c-5.844-.71-11.451 3.386-11.4 9.5v47.5h34.2zM295.9 157.2a9.5 9.5 0 00-9.5-9.5h-60.8a9.5 9.5 0 00-9.5 9.5v9.5h79.8z" />
            <path fill="currentColor" d="M90.7 243.384c-9.036 7.926-17.307 16.168-34.2 18.012V447.9h34.2zM417.5 119.2c.051-6.114-5.556-10.211-11.4-9.5V85.988a18.269 18.269 0 01-11.4 0V109.7c-5.844-.71-11.451 3.386-11.4 9.5v47.5h34.2zM421.3 243.384V447.9h34.2V261.4c-15.58-1.6-24.4-9.348-32.3-16.34-.608-.612-1.292-1.144-1.9-1.676zM484 459.3H28a9.5 9.5 0 00-9.5 9.5v24.7h475v-24.7a9.5 9.5 0 00-9.5-9.5zM362.4 245.056a51.843 51.843 0 01-75.924 0c-8.284-7.37-15.5-13.754-30.4-13.754-32.5.763-32.766 31-68.4 30.4-19.3 0-29.26-8.815-38-16.643-10.386-11.77-31.748-18.627-47.576-9.88V447.9h307.8V235.1c-15.86-8.583-37.05-1.867-47.5 9.956zM314.9 339.6a5.742 5.742 0 01-5.7 5.7h-32.3v77.9a5.742 5.742 0 01-5.7 5.7h-30.4a5.742 5.742 0 01-5.7-5.7v-77.9h-32.3a5.742 5.742 0 01-5.7-5.7v-30.4a5.742 5.742 0 015.7-5.7h32.3v-32.3a5.742 5.742 0 015.7-5.7h30.4a5.742 5.742 0 015.7 5.7v32.3h32.3a5.742 5.742 0 015.7 5.7z" />
            <path fill="currentColor" d="M265.5 309.2v-32.3h-19v32.3a5.742 5.742 0 01-5.7 5.7h-32.3v19h32.3a5.742 5.742 0 015.7 5.7v77.9h19v-77.9a5.742 5.742 0 015.7-5.7h32.3v-19h-32.3a5.742 5.742 0 01-5.7-5.7zM246.5 73.6v62.7h19V73.6a5.742 5.742 0 015.7-5.7h24.7v-19c-36.459-.5-29.861 5.939-30.4-30.4h-19c-.5 36.459 5.939 29.861-30.4 30.4v19h24.7a5.742 5.742 0 015.7 5.7zM111.6 79.185A10.952 10.952 0 00120 75.4a10.828 10.828 0 002.4-8.918l-3.852-22.993c-.861-7.8-12.994-7.807-13.893-.085l-3.861 23.056A10.775 10.775 0 00111.6 79.185zM400.4 79.185a10.952 10.952 0 008.4-3.781 10.828 10.828 0 002.4-8.918l-3.852-22.993c-.861-7.8-12.994-7.807-13.893-.085l-3.861 23.052A10.775 10.775 0 00400.4 79.185z" />
        </svg>
    )
}

// Icon dạng "ô vuông bo góc" (app tile) cho Giờ Lễ & Nhà Thờ - GHÉP 2 icon (pin định vị + nhà thờ,
// cùng cặp icon đã dùng ở ChurchLocationBadge/SpaceWebApps.js cho ĐÚNG feature này, không tự chế cặp
// icon khác) thành 1 hình: pin trắng làm nền, nhà thờ "khoét âm bản" cùng màu nền ô (teal-700, ĐÚNG
// tông teal đã gắn với trang /churches thật - xem cardBackground ở SpaceWebApps.js) để đọc thành 1
// khối liền thay vì 2 icon chồng lệch màu. Dùng cho danh sách sidebar (AppGroupBlock) - nơi mọi icon
// khác đều là icon đơn giản, dùng để phân biệt "Giờ lễ & Nhà thờ" nổi bật hơn 1 chút.
// showBadge: true (mặc định) - tắt khi bị dùng lại ở ngữ cảnh cỡ quá khác (icon mờ nền cỡ rất lớn,
// hoặc vòng tròn có sẵn quá nhỏ) - lúc đó chỉ còn pin, bỏ nhà thờ lồng trong - xem SectionHeroBanner
// (SpaceWebApps.js) và giải thích ở LibraryIconSvg.js.
export const MassTimeTileIcon = ({
                                     size = 32,
                                     fill = '#0f766e',          // màu icon ghim (pin)
                                     churchFill = '#fff',                 // màu icon nhà thờ, mặc định = bgColor để nổi trên nền, hoặc dùng fill nếu bỏ nền
                                     showBadge = true,
                                     className,
                                     style,
                                     ...props
                                 }) => {

    return (
        <div
            style={{
                width: size,
                height: size,
                backgroundColor: 'transparent',
                ...style, // giữ nguyên: cộng dồn style từ ngoài (vd drop-shadow từ AppGroupBlock), không bị đè mất nền
            }}
            className={classNames('flex-shrink-0 rounded-lg flex items-center justify-center', showBadge ? 'relative' : '', className)}
            {...props}>
            <FaLocationPin
                size={size}
                style={{color: fill, filter: 'drop-shadow(0px 1px 1px rgba(0,0,0,0.25))'}}
            />
            {showBadge && (
                <BiSolidChurch
                    size={size * 0.41}
                    style={{
                        color: churchFill ?? fill,
                        position: 'absolute',
                        top: '41%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }}
                />
            )}
        </div>
    );
};

export const MassTimePlaceFillSvg = ({size = 20, ...props}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path fill="currentColor" d="M12.331 29.743c.19.172.43.257.669.257s.479-.085.669-.257a45.342 45.342 0 002.544-2.528A7.942 7.942 0 0115 23c0-4.411 3.589-8 8-8 .259 0 .514.015.767.039A9.65 9.65 0 0024 13c0-6.065-4.935-11-11-11S2 6.935 2 13c0 7.361 9.909 16.364 10.331 16.743zM8.5 13c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5-4.5-2.019-4.5-4.5z" />
            <path fill="currentColor" d="M23 16c-3.86 0-7 3.141-7 7s3.14 7 7 7 7-3.141 7-7-3.14-7-7-7zm0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z" />
            <path fill="currentColor" d="M24 22.764V20a1 1 0 10-2 0v3c0 .155.036.309.105.447l1 2a1 1 0 001.789-.894z" />
        </svg>
    )
}